<template>
  <b-form-group
    label="5. Gedung Dan Bangunan Di Atas Tanah Milik"
    label-for="gedungBangunanTanahMilik"
    label-size="lg"
    label-class="pb-0 pt-0"
  >
    <b-form-select
      id="gedungBangunanTanahMilik"
      v-model="gedungBangunanTanahMilik"
      :state="stateGedungBangunanTanahMilik"
      :options="dataGedungBangunanTanahMilik"
    />
    <b-form-invalid-feedback
      v-for="(error, index) of errorsGedungBangunanTanahMilik"
      :key="index"
    >
      {{ error.$message }}
    </b-form-invalid-feedback>

    <b-col
      v-if="gedungBangunanTanahMilik === '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-radio
        v-model="isGedungBangunanTanahMilikTercatat"
        value="1"
        :state="stateIsGedungBangunanTanahMilikTercatat"
      >
        Sudah Tercatat
      </b-form-radio>

      <b-col
        v-if="isGedungBangunanTanahMilikTercatat == '1'"
        cols="11"
        offset-md="1"
        class="mt-1 pr-0"
      >
        <b-form-group
          label="PD/UKPD"
          label-for="gedungBangunanTanahMilikPdUkpd"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <v-select
            id="gedungBangunanTanahMilikPdUkpd"
            v-model="gedungBangunanTanahMilikPdUkpd"
            :options="dataPdUkpd"
            label="text"
            @input="inputGedungBangunanTanahMilikPdUkpd"
          />
          <small
            v-for="(error, index) of errorsGedungBangunanTanahMilik"
            :key="index"
            class="text-danger"
          >
            <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Pemerintah Daerah Provinsi DKI
              Jakarta</span>
            <span v-else>{{ error.$message }}</span>
          </small>
        </b-form-group>

        <b-form-group
          label="Kode Barang"
          label-for="gedungBangunanTanahMilikKobar"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <v-select
            id="gedungBangunanTanahMilikKobar"
            v-model="gedungBangunanTanahMilikKobar"
            :state="stateGedungBangunanTanahMilikKobar"
            :options="dataGedungBangunanTanahMilikKobar"
            label="text"
            @search="searchIndikasiGandaKobar"
            @input="inputGedungBangunanTanahMilikKobar"
          />
          <small
            v-for="(error, index) of errorsGedungBangunanTanahMilikKobar"
            :key="index"
            class="text-danger"
          >
            {{ error.$message }}
          </small>
        </b-form-group>

        <b-form-group
          label="Register"
          label-for="gedungBangunanTanahMilikRegister"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <v-select
            id="gedungBangunanTanahMilikRegister"
            v-model="gedungBangunanTanahMilikRegister"
            :state="stateGedungBangunanTanahMilikRegister"
            label="text"
            :options="dataGedungBangunanTanahMilikRegister"
          />
          <small
            v-for="(error, index) of errorsGedungBangunanTanahMilikRegister"
            :key="index"
            class="text-danger"
          >
            {{ error.$message }}
          </small>
        </b-form-group>
      </b-col>

      <b-form-radio
        v-model="isGedungBangunanTanahMilikTercatat"
        value="0"
        :state="stateIsGedungBangunanTanahMilikTercatat"
      >
        Belum Tercatat
      </b-form-radio>
      <small
        v-for="(error, index) of errorsIsGedungBangunanTanahMilikTercatat"
        :key="index"
        class="text-danger"
      >
        <span>{{ error.$message }}</span>
      </small>

      <b-col
        v-if="isGedungBangunanTanahMilikTercatat == '0'"
        cols="11"
        offset-md="1"
        class="mt-1 pr-0"
      >
        <b-form-group
          label="Keterangan"
          label-for="gedungBangunanTanahMilikKeterangan"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-input
            id="gedungBangunanTanahMilikKeterangan"
            v-model="gedungBangunanTanahMilikKeterangan"
            :state="stateGedungBangunanTanahMilikKeterangan"
          />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsGedungBangunanTanahMilikKeterangan"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-col>

    <b-col
      v-if="
        gedungBangunanTanahMilik === '2' ||
          gedungBangunanTanahMilik === '3' ||
          gedungBangunanTanahMilik === '4'
      "
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="Sebutkan"
        label-for="gedungBangunanTanahMilikSebutkan"
        label-size="lg"
        label-class="pb-0 pt-0"
      >
        <b-form-input
          id="gedungBangunanTanahMilikSebutkan"
          v-model="gedungBangunanTanahMilikSebutkan"
          :state="stateGedungBangunanTanahMilikSebutkan"
        />
        <b-form-invalid-feedback
          v-for="(error, index) of errorsGedungBangunanTanahMilikSebutkan"
          :key="index"
        >
          {{ error.$message }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
  </b-form-group>
</template>

<script>
import { ref, watchEffect, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import {
  propsString,
  propsBoolean,
  propsArray,
  propsObject,
} from '@/utils/propsTipeData'

export default {
  setup(props, context) {
    const gedungBangunanTanahMilik = ref(null)
    const isGedungBangunanTanahMilikTercatat = ref(null)
    const gedungBangunanTanahMilikPdUkpd = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikKobar = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikRegister = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikKeterangan = ref('')
    const gedungBangunanTanahMilikSebutkan = ref('')

    watch(gedungBangunanTanahMilik, () => {
      context.emit(
        'emitGedungBangunanTanahMilik',
        gedungBangunanTanahMilik.value,
      )
    })

    watch(isGedungBangunanTanahMilikTercatat, () => {
      context.emit(
        'emitIsGedungBangunanTanahMilikTercatat',
        isGedungBangunanTanahMilikTercatat.value,
      )
    })

    watch(gedungBangunanTanahMilikPdUkpd, () => {
      context.emit(
        'emitGedungBangunanTanahMilikPdUkpd',
        gedungBangunanTanahMilikPdUkpd.value,
      )
    })

    watch(gedungBangunanTanahMilikKobar, () => {
      context.emit(
        'emitGedungBangunanTanahMilikKobar',
        gedungBangunanTanahMilikKobar.value,
      )
    })

    watch(gedungBangunanTanahMilikRegister, () => {
      context.emit(
        'emitGedungBangunanTanahMilikRegister',
        gedungBangunanTanahMilikRegister.value,
      )
    })

    watch(gedungBangunanTanahMilikKeterangan, () => {
      context.emit(
        'emitGedungBangunanTanahMilikKeterangan',
        gedungBangunanTanahMilikKeterangan.value,
      )
    })

    watch(gedungBangunanTanahMilikSebutkan, () => {
      context.emit(
        'emitGedungBangunanTanahMilikSebutkan',
        gedungBangunanTanahMilikSebutkan.value,
      )
    })

    watchEffect(() => {
      gedungBangunanTanahMilik.value = props.gedungBangunanTanahMilikVal
      isGedungBangunanTanahMilikTercatat.value = props.isGedungBangunanTanahMilikTercatatVal
      gedungBangunanTanahMilikPdUkpd.value = props.gedungBangunanTanahMilikPdUkpdVal
      gedungBangunanTanahMilikKobar.value = props.gedungBangunanTanahMilikKobarVal
      gedungBangunanTanahMilikRegister.value = props.gedungBangunanTanahMilikRegisterVal
      gedungBangunanTanahMilikKeterangan.value = props.gedungBangunanTanahMilikKeteranganVal
      gedungBangunanTanahMilikSebutkan.value = props.gedungBangunanTanahMilikSebutkanVal
    })

    const inputGedungBangunanTanahMilikPdUkpd = () => {
      context.emit(
        'emitInputGedungBangunanTanahMilikPdUkpd',
        gedungBangunanTanahMilikPdUkpd.value,
      )
    }

    const inputGedungBangunanTanahMilikKobar = () => {
      context.emit(
        'emitInputGedungBangunanTanahMilikKobar',
        gedungBangunanTanahMilikKobar.value,
      )
    }

    const searchIndikasiGandaKobar = search => {
      context.emit(
        'emitSearchIndikasiGandaKobar',
        search,
      )
    }

    return {
      gedungBangunanTanahMilik,
      isGedungBangunanTanahMilikTercatat,
      gedungBangunanTanahMilikPdUkpd,
      gedungBangunanTanahMilikKobar,
      gedungBangunanTanahMilikRegister,
      gedungBangunanTanahMilikKeterangan,
      gedungBangunanTanahMilikSebutkan,
      inputGedungBangunanTanahMilikPdUkpd,
      inputGedungBangunanTanahMilikKobar,
      searchIndikasiGandaKobar,
    }
  },
  components: {
    vSelect,
  },
  props: {
    gedungBangunanTanahMilikVal: propsString,
    stateGedungBangunanTanahMilik: propsBoolean,
    errorsGedungBangunanTanahMilik: propsArray,
    isGedungBangunanTanahMilikTercatatVal: propsString,
    stateIsGedungBangunanTanahMilikTercatat: propsBoolean,
    errorsIsGedungBangunanTanahMilikTercatat: propsArray,
    gedungBangunanTanahMilikPdUkpdVal: propsObject,
    stateGedungBangunanTanahMilikPdUkpd: propsBoolean,
    errorsGedungBangunanTanahMilikPdUkpd: propsArray,
    dataPdUkpd: propsArray,
    gedungBangunanTanahMilikKobarVal: propsObject,
    dataGedungBangunanTanahMilikKobar: propsArray,
    stateGedungBangunanTanahMilikKobar: propsBoolean,
    errorsGedungBangunanTanahMilikKobar: propsArray,
    gedungBangunanTanahMilikRegisterVal: propsObject,
    stateGedungBangunanTanahMilikRegister: propsBoolean,
    dataGedungBangunanTanahMilikRegister: propsArray,
    errorsGedungBangunanTanahMilikRegister: propsArray,
    gedungBangunanTanahMilikKeteranganVal: propsString,
    stateGedungBangunanTanahMilikKeterangan: propsBoolean,
    errorsGedungBangunanTanahMilikKeterangan: propsArray,
    gedungBangunanTanahMilikSebutkanVal: propsString,
    stateGedungBangunanTanahMilikSebutkan: propsBoolean,
    dataGedungBangunanTanahMilikSebutkan: propsArray,
    errorsGedungBangunanTanahMilikSebutkan: propsArray,
  },
  data() {
    return {
      dataGedungBangunanTanahMilik: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Daerah Provinsi DKI Jakarta' },
        { value: '2', text: 'Pemerintah Pusat' },
        { value: '3', text: 'Pemerintah Daerah Lain' },
        { value: '4', text: 'Pihak Lain' },
      ],
    }
  },
}
</script>
